import { render, staticRenderFns } from "./type.vue?vue&type=template&id=6a2a15bf&scoped=true&"
import script from "./type.vue?vue&type=script&lang=js&"
export * from "./type.vue?vue&type=script&lang=js&"
import style0 from "./type.vue?vue&type=style&index=0&id=6a2a15bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2a15bf",
  null
  
)

export default component.exports